import{e as r}from"./ids-chunk-5Q3WPKMB.js";var n=(t,o,e)=>{let s=r(e);s?(o.setAttribute(t,`${s}`),o.container?.classList.add(t)):(o.removeAttribute(t),o.container?.classList.remove(t))};export{n as a};
